import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { orderBy, has, set, get, split } from 'lodash/fp';
import { Table, Icon, IconButton } from 'rsuite';
import Pagination from '../../Pagination';
import IconLink from '../../IconLink';
import DateCell from '../../widgets/custom-cell/Date';
import * as PERMISSIONS from '../../../constants/permissions/outreach';
import {
  viewAccess,
  modifyAccess,
  fullAccess
} from '../../../helpers/permission';
import AccessControl from '../../AccessControl';
// import DeleteConfirmationModal from '../../DeleteConfirmationModal';
import PaginationType from '../../../interfaces/PaginationType';

const { Column, HeaderCell, Cell } = Table;

const ActionCell = ({ rowData, dataKey, handleDelete, ...props }) => (
  <Cell {...props} className="link-group">
    <AccessControl allowOnlyFor={viewAccess(PERMISSIONS.OUTREACH)}>
      <IconLink
        icon="eye"
        to={{
          pathname: '',
          params: { id: rowData.id }
        }}
      />
    </AccessControl>
    <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.OUTREACH)}>
      <IconLink
        icon="edit2"
        to={{
          pathname: '',
          params: { id: rowData.id }
        }}
      />
    </AccessControl>
    <AccessControl allowOnlyFor={fullAccess(PERMISSIONS.OUTREACH)}>
      <IconButton
        style={{ top: '-8px' }}
        appearance="link"
        color="red"
        onClick={() => handleDelete(rowData)}
        icon={<Icon icon="trash" />}
      />
    </AccessControl>
  </Cell>
);

class OutreachList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // outreachToDelete: null,
      // showConfirmDelete: false
    };
  }

  componentDidMount() {
    const { onInit, isFetched } = this.props;
    if (!isFetched) {
      onInit();
    }
  }

  // componentDidUpdate({ isDeleted: prevIsDeleted }) {
  //   const { isDeleted } = this.props;
  //   if (!prevIsDeleted && isDeleted) {
  //     this.handleCloseDeleteModal();
  //   }
  // }

  getData() {
    const { outreaches } = this.props;
    const { sortColumn, sortType } = this.state;
    return orderBy(sortColumn, sortType, outreaches);
  }

  handleSortColumn = (sortColumn, sortType) => {
    const { onSort, query } = this.props;
    onSort(sortColumn, sortType, query);
  };

  // handleOpenDeleteModal = outreachToDelete => {
  //   this.setState({ showConfirmDelete: true, outreachToDelete });
  // };

  // handleCloseDeleteModal = () => {
  //   this.setState({ showConfirmDelete: false });
  // };

  // handlConfirmDelete = () => {
  //   const { outreachToDelete } = this.state;
  //   const { onDelete } = this.props;
  //   onDelete(outreachToDelete);
  // };

  handleChangePage = page => {
    const { onChangePage, loadedPages, query } = this.props;
    const isPageLoaded = has(page, loadedPages);
    const nextPageQuery = set('page', page, query);
    onChangePage(nextPageQuery, isPageLoaded);
  };

  handleChangeLimit = limit => {
    const { onChangeLimit, query } = this.props;
    const newQuery = { ...query, limit, page: 1 };
    onChangeLimit(newQuery);
  };

  renderPagination() {
    const { pagination } = this.props;
    return (
      <Pagination
        page={pagination.currentPage}
        limit={pagination.limit}
        total={pagination.totalCount}
        onChangePage={this.handleChangePage}
        onChangeLimit={this.handleChangeLimit}
      />
    );
  }

  render() {
    const { isFetching, query } = this.props;
    const [sortColumn, sortType] = split(':', get('order', query));
    // const { outreachToDelete, showConfirmDelete } = this.state;
    return (
      <Fragment>
        <Table
          height={420}
          loading={isFetching}
          data={this.getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={this.handleSortColumn}
        >
          <Column width={60} align="center" fixed sortable>
            <HeaderCell>Id</HeaderCell>
            <Cell dataKey="id" />
          </Column>
          <Column width={200} fixed sortable>
            <HeaderCell>Name</HeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column width={200} sortable>
            <HeaderCell>Outreach Date</HeaderCell>
            <DateCell dataKey="outreachOn" format="MM/DD/YYYY hh:mm A" />
          </Column>
          <Column width={140} sortable>
            <HeaderCell>Date Created</HeaderCell>
            <DateCell dataKey="createdAt" />
          </Column>
          <Column width={200}>
            <HeaderCell align="center">Action</HeaderCell>
            <ActionCell
              align="center"
              dataKey="id"
              handleDelete={this.handleOpenDeleteModal}
            />
          </Column>
        </Table>

        {this.renderPagination()}

        {/* {outreachToDelete && (
          <DeleteConfirmationModal
            show={showConfirmDelete}
            onHide={this.handleCloseDeleteModal}
            onConfirm={this.handlConfirmDelete}
            isDeleting={isDeleting}
          />
        )} */}
      </Fragment>
    );
  }
}

ActionCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ id: PropTypes.number }),
  handleDelete: PropTypes.func
};

ActionCell.defaultProps = {
  rowData: null,
  handleDelete: () => {}
};

OutreachList.propTypes = {
  outreaches: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetching: PropTypes.bool.isRequired,
  isFetched: PropTypes.bool.isRequired,
  // isDeleting: PropTypes.bool.isRequired,
  // isDeleted: PropTypes.bool.isRequired,
  onInit: PropTypes.func.isRequired,
  // onDelete: PropTypes.func.isRequired,
  query: PropTypes.shape({}).isRequired,
  loadedPages: PropTypes.shape({}).isRequired,
  pagination: PaginationType.isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired
};

export default OutreachList;
